import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import XLSX from 'xlsx/dist/xlsx.core.min';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()

export class ExcelService {

  constructor() { }

  exportAsExcelFile(json: any[], excelFileName: string, header?: any[]): void {
    const final = header ? this.formatExcelData(json) :  [];
    const worksheet: XLSX.WorkSheet =  final.length ? XLSX.utils.aoa_to_sheet([header, ...final ]) : XLSX.utils.json_to_sheet(final);
    const workbook: XLSX.WorkBook = { Sheets: {data: worksheet },SheetNames: ['data'] };  
    const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array',  compression: true });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  renameKeys(obj, newKeys) {
    const obj3Array = this.getObjectValues(obj);
    const obj4Array = this.getObjectValues(newKeys);
    const obj3: any = {};
    for (let i = 0; i < obj3Array.length; i++) {
      obj3[obj4Array[i]] = obj3Array[i];
    }
    return obj3;
  }

  getObjectValues(obj) {
    const objArray: any = [];
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const element = obj[key];
        objArray.push(element);
      }
    }
    return objArray;
  }

  excelHeaderTranslation(headers, header) {
    const newArray = [];
    const newObj = Object.assign({}, header);
    headers.forEach(element => {
      const renamedObj = this.renameKeys(element, newObj);
      newArray.push(renamedObj);
    });
      return newArray;
   }

   formatExcelData(json: object[]) {
        const dataRows = json.map(row =>
        Object.keys(row).map(key => row[key])
        );
        return dataRows;
   }
}
